import { useSelector } from "react-redux";
import React, { Suspense } from "react";

import Loading from "../../Global-W/Classes/Loading";

const Footer = React.lazy(() => import("./Footer"));

const LiceoFooter = React.lazy(() => import("./LiceoFooter"));

export default function Default(props) {
  const { app } = useSelector((state) => state.rooot);

  return (
    <Suspense fallback={<Loading />}>
      {app === "liceo" ? <LiceoFooter /> : <Footer />}
    </Suspense>
  );
}